<div mat-dialog-title>
  <span>{{ 'SIDEBAR.EDIT_NODE' | translate }}</span>

  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>

<form [formGroup]="editNodeForm" #form="ngForm">
  <mat-dialog-content class="content">
    <q9-text-field
      [isRequired]="nameRequired"
      [placeholder]="'SIDEBAR.NODE_TITLE_PH' | translate"
      label="SIDEBAR.NODE_TITLE"
      formControlName="name"></q9-text-field>
    <q9-text-field
      [isRequired]="customIdRequired"
      [placeholder]="'SIDEBAR.CUSTOM_ID_PH' | translate"
      label="SIDEBAR.CUSTOM_ID"
      formControlName="customId"></q9-text-field>
    <q9-textarea-field
      [placeholder]="'SIDEBAR.DESCRIPTION_PH' | translate"
      label="SIDEBAR.DESCRIPTION"
      formControlName="description"></q9-textarea-field>
  </mat-dialog-content>
</form>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>{{ 'GENERAL.CANCEL_BTN' | translate }}</q9-secondary-button>
  <q9-primary-button
    [isLoading]="isSubmitted"
    (click)="!isSubmitted && form.onSubmit($event); onSubmit()">
    {{ 'GENERAL.SAVE' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
